import { Globe, Instagram, Facebook, Youtube, Linkedin } from "lucide-react";
import PlatformButton from "@/components/PlatformButton";

// "Official Brand Presence" -- the ONLY platform-link area on a brand
// page. Website, Instagram, Facebook, YouTube, LinkedIn. Any channel
// without a configured URL renders as a clearly disabled "Coming Soon"
// pill instead of a dead or duplicated link.
const CHANNELS = [
  { key: "website", label: "Website", icon: Globe },
  { key: "instagram", label: "Instagram", icon: Instagram },
  { key: "facebook", label: "Facebook", icon: Facebook },
  { key: "youtube", label: "YouTube", icon: Youtube },
  { key: "linkedin", label: "LinkedIn", icon: Linkedin },
];

const BrandPresence = ({ website, instagram, facebook, youtube, linkedin }) => {
  const urls = { website, instagram, facebook, youtube, linkedin };

  return (
    <div className="neu-panel p-8 md:p-10" data-testid="brand-presence-section">
      <span className="eyebrow block mb-6">Official Brand Presence</span>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
        {CHANNELS.map(({ key, label, icon }) => (
          <PlatformButton
            key={key}
            href={urls[key]}
            label={label}
            icon={icon}
            testId={urls[key] ? `brand-presence-${key}-link` : `brand-presence-${key}-comingsoon`}
          />
        ))}
      </div>
    </div>
  );
};

export default BrandPresence;
